import httpClient from "@/api/httpClient";
import {
  ICommonProduct,
  IProduct,
  ISearchProductResponse,
} from "./products.interface";
import { IPagination } from "@/commons/commons.interfaces";

export const getProductsService = async (
  page: number = 0,
  limit: number = 10,
  sort: string = "",
  order: "asc" | "desc" | "" = "",
  search: string = ""
): Promise<{ pagination: IPagination; products: IProduct[] }> => {
  try {
    const params: any = {
      page,
      limit,
    };

    if (sort) {
      params.sort = sort;
    }
    if (order) {
      params.order = order;
    }
    if (search) {
      params.search = search;
    }

    const response = await httpClient.get("/v1/product", { params });
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const getProductService = async (id: string): Promise<IProduct> => {
  try {
    const response = await httpClient.get(`/v1/product/${id}`);
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const addProductService = async (
  product: ICommonProduct
): Promise<IProduct> => {
  try {
    const response = await httpClient.post("/v1/product", product);
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const updateProductService = async (
  id: string,
  product: ICommonProduct
): Promise<IProduct> => {
  try {
    const response = await httpClient.patch(`/v1/product/${id}`, product);
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const deleteProductService = async (id: string): Promise<IProduct> => {
  try {
    const response = await httpClient.delete(`/v1/product/${id}`);
    return response.data;
  } catch (e) {
    throw e;
  }
};

export const searchProductsService = async (
  search: string
): Promise<ISearchProductResponse[]> => {
  try {
    const response = await httpClient.get("/v1/product/search", {
      params: { q: search },
    });
    return response.data;
  } catch (e) {
    throw e;
  }
};
